// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SisaText {\n  white-space: pre-line;\n}", "",{"version":3,"sources":["webpack://./components/SisaText/index.sass"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF","sourcesContent":[".SisaText\n  white-space: pre-line\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
